
function applyGeocoding(map,locale) {
    /* Geocoding support (optional as well) */

    let apikey = '7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2',
        apikeypart = 'api-key=' + apikey,
        geocoding_search_url =
            'https://avoin-paikkatieto.maanmittauslaitos.fi/geocoding/v2/geoportal/search?' + apikeypart + '&',
        geocoding_similar_url =
            'https://avoin-paikkatieto.maanmittauslaitos.fi/geocoding/v2/searchterm/similar?' + apikeypart + '&';



    var geocoding_controller = new AbortController(),
        geocoding_signal = geocoding_controller.signal;

    function geocoding_click(e) {
        let eDataset = e.target.dataset,
            eType = eDataset.geocodingType,
            elSearch = document.getElementById('geocoding_search');

        switch (eType) {
            case 'result':
                var coord = [Number(eDataset.geocodingResultPointLon), Number(eDataset.geocodingResultPointLat)];
                console.log("LOCATION FOR ", eDataset.geocodingResultText, coord);
                map.getView().setCenter(coord);
                map.getView().setZoom(11);
                break;
            case 'similar':
                var text = eDataset.geocodingValueSimilar;
                elSearch.value = '"' + text + '"';
                geocoding_results(text);
                geocoding_similar(text);
                break;
        }
    }

    function geocoding_add_to_map(json) {
/*        if (!map.getSource('point')) {
            return;
        }

        map.getSource('point').setData(json);
    */    }

    function geocoding_reset_list(listEl) {
        while (listEl.firstChild) {
            listEl.firstChild.removeEventListener(listEl.firstChild, geocoding_click);
            listEl.firstChild.remove();
        }
    }
    function geocoding_update_list(listEl, list, f) {
        list.map(f).forEach(el => {
            listEl.appendChild(el)
            el.addEventListener('click', geocoding_click);
        });
    }

    function geocoding_results(text, resetList) {
        let listEl = document.getElementById('geocoding_results');

        if (!text || text == '') {
            geocoding_reset_list(listEl);
            return;
        } else if (resetList) {
            geocoding_reset_list(listEl);
        }

        // ?lang=fin&crs=http://www.opengis.net/def/crs/EPSG/0/4326&size=50&text=Pasila
        let url = geocoding_search_url + new URLSearchParams({
            lang: 'fin',
            crs: 'http://www.opengis.net/def/crs/EPSG/0/3067',
            size: 30,
            text: text
        });

        fetch(url, {
            method: 'get',
            signal: geocoding_signal
        }).then(response => response.json()).then(json => {
            geocoding_add_to_map(json);
            geocoding_reset_list(listEl);
            var arr = json.features ? json.features.map(a => {
                var labelText = a.properties.label,
                    labelInfoText = [
                        a.properties['label:municipality'],
                        a.properties['label:region'],
                        //            a.properties['label:subregion'],
                        a.properties['label:placeType']//,
                        //            a.properties['label:placeTypeCategory'],
                    ].join(' / ');

                return { text: labelText, info: labelInfoText, location: a.geometry.coordinates };
            }) : [];
            geocoding_update_list(listEl, arr, res => {
                var el = document.createElement('div');

                var elLink = document.createElement('a');
                elLink.classList.add('geocoding_result');
                elLink.innerHTML = res.text;

                let attrs = {
                    'href': 'javascript:void(0)',
                    'data-geocoding-type': 'result',
                    'data-geocoding-result-text': res.text,
                    'data-geocoding-result-point-lon': res.location[0],
                    'data-geocoding-result-point-lat': res.location[1]
                };
                for (let [key, value] of Object.entries(attrs)) {
                    elLink.setAttribute(key, value)
                }
                el.appendChild(elLink);
                var elInfo = document.createElement('span');
                elInfo.classList.add('geocoding_result');
                elInfo.innerHTML = res.info;
                el.appendChild(elInfo);

                return el;
            });
        }).catch(function (err) {
            geocoding_reset_list(listEl);
        });


    }



    function geocoding_similar(text, resetList) {
        let listEl = document.getElementById('geocoding_similar');

        if (!text || text == '') {
            geocoding_reset_list(listEl);
            return;
        } else if (resetList) {
            geocoding_reset_list(listEl);

        }

        // ?size=10&text=pasila
        let url = geocoding_similar_url + new URLSearchParams({
            lang: 'fin',
            size: 10,
            text: text
        });


        fetch(url, {
            method: 'get',
            signal: geocoding_signal
        }).then(response => response.json()).then(json => {
            geocoding_reset_list(listEl);

            var arr = json.terms ? json.terms.map(a => { return { text: a.text }; }) : [];
            geocoding_update_list(listEl, arr, res => {
                var el = document.createElement('a');
                el.classList.add('geocoding_similar');

                let attrs = {
                    'href': 'javascript:void(0)',
                    'data-geocoding-type': 'similar',
                    'data-geocoding-value-similar': res.text
                };
                for (let [key, value] of Object.entries(attrs)) {
                    el.setAttribute(key, value)
                }

                el.innerHTML = res.text;
                return el;
            });

        }).catch(function (err) {
            geocoding_reset_list(listEl);
        });

    }

    document.getElementById('geocoding_reset').addEventListener('click', e => {
        document.getElementById('geocoding_search').value = '';
        if (geocoding_controller) {
            geocoding_controller.abort();
            /* don't know how to reuse - aborts early if reused */
            geocoding_controller = new AbortController();
            geocoding_signal = geocoding_controller.signal;
        }
        geocoding_results();
        geocoding_similar();

    });

    document.getElementById('geocoding_search').addEventListener('input',
        e => {
            var text = e.target.value;
            console.log(text);
            if (geocoding_controller) {
                geocoding_controller.abort();
                /* don't know how to reuse - aborts early if reused */
                geocoding_controller = new AbortController();
                geocoding_signal = geocoding_controller.signal;
            }
            geocoding_results(text);
            geocoding_similar(text);
        }
    )

}

export default applyGeocoding;